/* Kept out of the route config so consumers can reference a route without an import cycle. */
export const EDIT_PROJECT_ROUTE_IDS = {
  ROOT: 'edit-project-root',
  ROOT_WITH_LANGUAGE: 'edit-project-root-with-language',

  OVERVIEW: 'edit-project-overview',
  SESSION: 'edit-project-session',
  AGENDA: 'edit-project-agenda',
  CAST_AND_CREW: 'edit-project-cast-and-crew',
  CALENDAR: 'edit-project-calendar',
  TASKS: 'edit-project-tasks',
  CREATIVE_BOARDS: 'edit-project-creative-boards',
  MODERATOR: 'edit-project-moderator',
  GREENROOM: 'edit-project-greenroom',
  CONTENT: 'edit-project-content',
  LIVE_MONITOR: 'edit-project-live-monitor',
  SEGMENTS: 'edit-project-segments',
  RUN_OF_SHOW: 'edit-project-run-of-show',
  SCRIPTS: 'edit-project-scripts',
  SLIDES: 'edit-project-slides',
  SETTINGS: 'edit-project-settings',
  PREVIEW_TEMPLATE: 'edit-project-preview-template',

  STYLEPACKS: 'edit-project-stylepacks',
  STYLEPACKS_INDEX: 'stylepacks',
  STYLEPACKS_BROWSE: 'stylepacks/browse',
  PREVIEW_STYLEPACK: 'preview-stylepack',

  AUDIENCES: 'edit-project-audiences',
  AUDIENCE_LISTS: 'edit-project-audiences-tabs-lists',
  AUDIENCE_LIST: 'edit-project-audiences-list',
  REGISTRANTS_LIST: 'edit-project-registrants-list',
  USERS_LIST: 'edit-project-users-list',

  CAMPAIGNS: 'edit-project-campaigns',
  CAMPAIGNS_LIST: 'campaigns-list',
  CAMPAIGN_EDITOR: 'campaign-editor',

  /* Open another app -- no route of their own, but keyed the same way. */
  LEADERBOARD: 'edit-project-leaderboard',
  COURSES: 'edit-project-courses',
  CONTROL_ROOM: 'edit-project-control-room',
};
